"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FileUploader = _interopRequireDefault(require("../../Inputs/FileUploader"));

var _MiniProgressBar = _interopRequireDefault(require("../../IconicDisplayElements/MiniProgressBar"));

var _formatters = require("../../../helpers/formatters");

var _asyncStages = require("../../../constants/asyncStages");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DocumentUpload = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DocumentUpload, _React$PureComponent);

  var _super = _createSuper(DocumentUpload);

  function DocumentUpload() {
    var _this;

    _classCallCheck(this, DocumentUpload);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleFileUpload", function (file) {
      _this.props.fileUpload(file);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUploadCancel", function () {
      _this.props.uploadCancel();
    });

    _defineProperty(_assertThisInitialized(_this), "calculatePercentComplete", function () {
      var _this$props = _this.props,
          currentStage = _this$props.currentStage,
          uploadStages = _this$props.uploadStages;

      if (currentStage === _asyncStages.STAGED) {
        return 0;
      } // short-circuit the rest of this if current state is 'staged'


      var hasStagedState = uploadStages.indexOf(_asyncStages.STAGED) >= 0; // staged state will cause the progress bar to be visible, but is not used in calculating progress

      var stageIncrement = 100 / (uploadStages.length - (hasStagedState ? 2 : 1));
      var stageIndex = uploadStages.indexOf(currentStage);

      if (stageIndex < 0) {
        return console.warn("".concat(currentStage, " is not included in the recognized stages for this component")); // eslint-disable-line no-console
      }

      var roughValue = stageIncrement * (hasStagedState ? stageIndex - 1 : stageIndex);
      return roughValue >= 0 ? roughValue : 0;
    });

    _defineProperty(_assertThisInitialized(_this), "determineLeftIcon", function () {
      var _this$props2 = _this.props,
          currentStage = _this$props2.currentStage,
          uploadStages = _this$props2.uploadStages;
      var stageIndex = uploadStages.indexOf(currentStage);

      if (stageIndex === 0 || stageIndex < 0 || currentStage === _asyncStages.STAGED // we do not want to show the spinner icon when the file is just staged
      ) {
          return '';
        }

      if (stageIndex === uploadStages.length - 1) {
        return 'check-circle';
      }

      return 'spinner';
    });

    _defineProperty(_assertThisInitialized(_this), "determineSpin", function () {
      var _this$props3 = _this.props,
          currentStage = _this$props3.currentStage,
          uploadStages = _this$props3.uploadStages;
      var stageIndex = uploadStages.indexOf(currentStage);
      return !(stageIndex === 0 || stageIndex < 0 || stageIndex === uploadStages.length - 1 || currentStage === _asyncStages.STAGED); // no need to spin if staged as we hide the icon
    });

    _defineProperty(_assertThisInitialized(_this), "formatProgressMessage", function () {
      var _this$props4 = _this.props,
          currentStage = _this$props4.currentStage,
          fileName = _this$props4.fileName,
          uploadStages = _this$props4.uploadStages;

      if (currentStage === _asyncStages.FAILURE) {
        return "".concat(fileName, " (Upload Failed)");
      }

      var stageIndex = uploadStages.indexOf(currentStage);

      if (stageIndex < 1) {
        return '';
      }

      if (stageIndex >= uploadStages.length - 1) {
        return fileName;
      }

      return "".concat(fileName, " (").concat((0, _formatters.toTitleCase)(currentStage), ")");
    });

    _defineProperty(_assertThisInitialized(_this), "determineDisabledState", function () {
      var _this$props5 = _this.props,
          currentStage = _this$props5.currentStage,
          uploadStages = _this$props5.uploadStages;
      var stageIndex = uploadStages.indexOf(currentStage);

      if (currentStage === _asyncStages.NOT_STARTED || currentStage === _asyncStages.SUCCESS || currentStage === _asyncStages.FAILURE || stageIndex < 0) {
        return false;
      }

      return true;
    });

    return _this;
  }

  _createClass(DocumentUpload, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          className = _this$props6.className,
          dataTestId = _this$props6.dataTestId,
          currentStage = _this$props6.currentStage,
          requirements = _this$props6.requirements;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: className,
        "data-test-id": dataTestId
      }, currentStage !== _asyncStages.NOT_STARTED && currentStage !== _asyncStages.FAILURE && /*#__PURE__*/_react.default.createElement(_MiniProgressBar.default, {
        dataTestId: "document-upload-progress-bar",
        leftIconName: this.determineLeftIcon(),
        leftIconSpin: this.determineSpin(),
        percentComplete: this.calculatePercentComplete(),
        rightIconName: "times",
        rightIconColorTheme: "primary",
        rightIconClickHandler: this.handleUploadCancel,
        progressMessage: this.formatProgressMessage()
      }), currentStage === _asyncStages.FAILURE && /*#__PURE__*/_react.default.createElement(_MiniProgressBar.default, {
        dataTestId: "document-upload-progress-bar",
        percentComplete: 100,
        leftIconName: "exclamation-triangle",
        leftIconcolorTheme: "overDark",
        rightIconName: "times",
        rightIconcolorTheme: "overDark",
        rightIconClickHandler: this.handleUploadCancel,
        progressMessage: this.formatProgressMessage(),
        error: true
      }), /*#__PURE__*/_react.default.createElement(_FileUploader.default, {
        dataTestId: "c-document-upload-file-uploader",
        fileUploadHandler: this.handleFileUpload,
        disabled: this.determineDisabledState(),
        requirements: requirements
      }));
    }
  }]);

  return DocumentUpload;
}(_react.default.PureComponent);

DocumentUpload.propTypes = {
  /** Component styling override */
  className: _propTypes.default.string,

  /** Current Upload Stage */
  currentStage: _propTypes.default.string.isRequired,

  /** Id for testing */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag for triggering the file upload immediately after selecting file */

  /** The name of the file being uploaded */
  fileName: _propTypes.default.string,

  /** This is how you get the files out of the computer .. or the component in this case. Give me a
   * function that will let me send the parent the file that was uploaded. Or don't. Your choice.
   */
  fileUpload: _propTypes.default.func.isRequired,

  /** This allows the user to tell you that they uploaded the wrong file. Probably a picture of their cat or something. */
  uploadCancel: _propTypes.default.func.isRequired,

  /**
   * An array that lists the upload progress stages that this component will respond to.
   *
   * Array should start with 'NOT_STARTED' and end with 'SUCCESS'.
   *
   * Unsuccessful calls are handled outside of this array.
  */
  uploadStages: _propTypes.default.arrayOf(_propTypes.default.string),

  /** String that represents the file requirements for upload, such as extension and filesize. */
  requirements: _propTypes.default.string
};
DocumentUpload.defaultProps = {
  className: undefined,
  fileName: '',
  uploadStages: [_asyncStages.NOT_STARTED, _asyncStages.STAGED, _asyncStages.WAITING, _asyncStages.SUCCESS],
  requirements: ''
};
var _default = DocumentUpload;
exports.default = _default;